/**
 * Generate unique long string suitable for HTML ID starting with a letter.
 * You should not use it in SSR components. Find a way there to use React useId()
 */
export const generateRandomString = () => `${getRandomLetter()}${Math.random().toString(32).substring(4)}`;

const start = 'a'.charCodeAt(0);
const end = 'z'.charCodeAt(0);

const getRandomLetter = () => {
    const randomCharCode = Math.floor(Math.random() * (end - start + 1)) + start;
    return String.fromCharCode(randomCharCode);
};
